import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "installer-heading" }
const _hoisted_2 = { class: "installer-heading-wrap" }

import { computed } from 'vue';

import useUser from '@/composables/useUser';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallerHeading',
  setup(__props) {

const { user } = useUser();
const { websiteText } = useWebsiteTexts();

const hasInstallerData = computed(() => {
  return user.value?.organization?.installerData;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(hasInstallerData)
          ? _unref(websiteText)('mypages__edit_installer_caption').value
          : _unref(websiteText)('mypages__become_an_installer_caption').value), 1),
    _createElementVNode("p", null, _toDisplayString(_unref(websiteText)('mypages__become_an_installer_description').value), 1)
  ]))
}
}

})